import { GetCompaniesDocument } from '@/api/queries';
import SelectFromQuery from '../SelectFromQuery';

const SelectCompany = (props) => (
  <SelectFromQuery
    cache="Company"
    placeholder="All Companies"
    query={GetCompaniesDocument}
    selector={(data) => {
      return (data?.getFilters?.filters?.companies || []).map((opt) => ({
        label: opt.displayName,
        value: opt.id,
      }));
    }}
    {...props}
  />
);

export default SelectCompany;
